/**
 * @description 意见反馈接口
 * @author cjs1992
 * @date 2020-08-21 15:02:09
 */
import { request } from "@/api/axios.js";
const url = "/portal-ywtb/web/problem/";
/**
 * @name getGuidelineByCon
 * @description 根据事项名称或者事项id查询事项列表
 * @param {
 *  startPage int 开始页
 *  pageSize int 每页条数
 *  guidelineId int 事项ID
 *  guidelineName string 事项名称
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-08-21 15:02:51
 */
export function getGuidelineByCon(data = {}, config = {}) {
  return request({
    method: "post",
    url: `${url}getGuidelineByCon`,
    data,
    ...config
  });
}
/**
 * @name addProblem
 * @description 提交反馈
 * @param {
 *  problemType 反馈类型  1 产品建议 2 功能异常 3 办事建议 4 其他建议
 *  problemDesc  反馈意见
 *  phone  联系方式
 *  guidelineId 关联事项id
 *  needReply 是否需要回复  1 是  0 否
 *  fileList  附件列表
 *  appType  来源类型  1
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-08-21 15:27:18
 */
export function addProblem(data = {}, config = {}) {
  data.appType = 1;
  return request({
    method: "post",
    url: `${url}addProblem`,
    data,
    ...config
  });
}
/**
 * @name getProblemList
 * @description 获取反馈列表
 * @param {
 *  problemType 反馈类型  1 产品建议 2 功能异常 3 办事建议 4 其他建议
 *  guidelineId 关联事项id
 *  needReply 是否需要回复  1 是  0 否
 *  replyStatus 回复状态(-1无需回复0未回复1已回复)
 *  startTime
 *  endTime
 *  pageNum
 *  pageSize
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-08-21 15:32:20
 */
export function getProblemList(data = {}, config = {}) {
  return request({
    method: "post",
    url: `${url}getProblemList`,
    data,
    ...config
  });
}
/**
 * @name getProblemById
 * @description 获取反馈详情
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-08-21 17:32:09
 */
export function getProblemById(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getProblemById`,
    params: data,
    ...config
  });
}
/**
 * @name configList
 * @description 获取配置数据
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-08-24 10:30:33
 */
export function configList(data = {}, config = {}) {
  return request({
    method: "post",
    url: `/portal-ywtb/manage/problem/configList`,
    data,
    ...config
  });
}



// WEBPACK FOOTER //
// ./src/api/feedBack.js